import React, { useEffect, useState } from 'react'
import {RouteComponentProps}from 'react-router'
import { connect } from 'react-redux';
import {Dispatch} from "redux";
import styled from 'styled-components'
import {useAuth0} from "../../helpers/react-auth0-spa"
import {IAppState} from "../../db/reducers";
import { createPollFb, deletePollFb, fetchPollStateFb } from "../../db";
import {useHistory} from "react-router-dom";
import Drawer, { DrawerType } from "../Drawer";
import AdminPollTable from "./AdminPollTable"
import { device } from '../../theme';

const SContainer = styled.div`
  flex-direction: column;
  align-items: center;
  width: 90vw;

  @media ${device.tablet}, (orientation: landscape) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const SSidePane = styled.div`
  flex-direction: column;
  width: 15vw;
`;

const SSidePaneHeader = styled.div`
  height: 10vh;
`

const SSidePaneTable = styled.div`
`

const SMain = styled.div`
  flex-direction: column;
  width: 75vw;
`

const SMainHeader = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 10vh;
  width: 75vw;
  margin-bottom: 2em;

  @media ${device.tablet}, (orientation: landscape) {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }  
`

const SMainTable = styled.div`
  width: 75vw;
  display: none;
  
  @media ${device.tablet}, (orientation: landscape) {
    display: flex;
  }
`;

const SMainTableAlt = styled.div`
  width: 75vw;
  display: flex;

  @media ${device.tablet}, (orientation: landscape) {
    display: none;
  }
`;

interface IPoll {
  owner: string;
  scores: {
    [scoreId: string]: string; // scoreId is a timestamp,
  };
}

interface IAdminHome extends RouteComponentProps {
  createPoll(pollId: string, pollOwner: string): void,
  deletePoll(pollId: string): void;
  getPollsList(): void;
  filterPolls(): any[];
  polls?: {
    [pollId: string]: IPoll
  };
}

const AdminHome: React.SFC<IAdminHome> = (props) => {
  const { isAuthenticated, user } = useAuth0();
  const history = useHistory();
  const [currentPollId, setCurrentPollId] = useState('');
  const [showCreateWindow, setShowCreateWindow] = useState(false);
  const [showDeleteWindow, setShowDeleteWindow] = useState(false);

  const { getPollsList, polls } = props

  useEffect(() => {
    getPollsList();
  }, [getPollsList]);

  const filterPolls = () => {
    if (!polls || Object.keys(polls).length < 1) { return [] }
    
    // TODO: Refactor this out to the dispatcher
    const filteredPolls = Object.keys(polls).filter((pollKey: string) => {
      if (!polls[pollKey]) { return null }
      return polls[pollKey].owner.sub === user.sub
    })

    const reducedPolls = filteredPolls.map((pollKey: string) => {
      return { name: pollKey, ...polls[pollKey] }  
    })

    return reducedPolls
  }

  const setShowDeleteWindowDrill = (st8: boolean) => setShowDeleteWindow(st8)
  const setCurrentPollIdDrill = (pollId: string) => setCurrentPollId(pollId)

  return (
        <>
            {!isAuthenticated && history.push('/')}
            {showCreateWindow && <Drawer isDrawerVisible={showCreateWindow} setDrawerVisible={setShowCreateWindow} type={DrawerType.CREATE}/>}
            {showDeleteWindow && <Drawer pollId={currentPollId} isDrawerVisible={showDeleteWindow} setDrawerVisible={setShowDeleteWindow} type={DrawerType.DELETE}/>}
            <SContainer className={'AdminHome'}>
                <SSidePane className={'AdminSidePane'}>
                  <SSidePaneHeader className={'AdminSidePaneHeader'}/>
                  <SSidePaneTable>
                    <button onClick={() => setShowCreateWindow(true)}>New Poll!</button>
                  </SSidePaneTable>
                </SSidePane>
                <SMain className={'Admin SMain'}>
                    <SMainHeader className={'Admin MainHeader'}>
                      <p style={{ alignContent: 'flex-start', justifyContent: 'flex-start', margin: '1vh 1vw 1vh 1vw', fontWeight: 'bolder'}}>
                        Welcome, {user && user.nickname}
                      </p>
                      <p style={{ alignContent: 'flex-start', justifyContent: 'flex-start', margin: '1vh 1vw 1vh 1vw', fontWeight: 'lighter'}}>
                        As an admin, you can create new polls and see metrics for the polls you have already created.
                      </p>
                    </SMainHeader>
                    <SMainTableAlt>
                      <p style={{margin: 0}}>Turn landcape to view table.</p>  
                    </SMainTableAlt>
                    <SMainTable className={'Admin SMainTable'}>
                      <AdminPollTable polls={filterPolls()} setShowDeleteWindow={setShowDeleteWindowDrill} setCurrentPollId={setCurrentPollIdDrill}/>
                    </SMainTable>
                </SMain>
            </SContainer>
        </>
    )
}

const mapStateToProps = (state: IAppState) => ({
  polls: state.polls,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
      getPollsList: async () => {
        await fetchPollStateFb(dispatch);
      },
      createPoll: (currentPollId: string, currentPollOwner: string) => {
          createPollFb(currentPollId, currentPollOwner)(dispatch);
      },
      deletePoll: (currentPollId: string) => {
        deletePollFb(currentPollId)(dispatch)
      }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminHome)